export const Div = ({ children, classes, styles }) => (
  <div className={classes} style={styles}>
    {children}
  </div>
);



// WEBPACK FOOTER //
// ./components/common/div.tsx